import { getDesktopApi } from '@renderer/lib/desktop-api';

export function toTelUrl(phone: string): string {
  const trimmed = phone.trim();
  const cleaned = trimmed.replace(/[^\d+]/g, '');
  const normalized = cleaned.startsWith('+') ? `+${cleaned.slice(1).replace(/[^\d]/g, '')}` : cleaned.replace(/[^\d]/g, '');
  return `tel:${normalized}`;
}

export async function openExternal(url: string): Promise<void> {
  await getDesktopApi().system.openExternal(url);
}

